export const STUDIO_IDS_EXCLUDED_FROM_CAMPAIGN_POPUP: string[] = [
  '018cce35-7628-71dd-8fbd-5fb9dd9c44d3',
]
